module.exports = __webpack_public_path__ + "img/c5control.c34f9af2.gif";